import { Colors } from '@utex/ui-kit';
export var headerButtonView = {
    white: {
        static: {
            color: Colors.text.inverse,
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
        },
        hover: {
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
        },
        active: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        focus: {
            boxShadowColor: 'rgba(255, 255, 255, 0.4)',
        },
    },
    'white-dim': {
        static: {
            color: Colors.text.inverse,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
        hover: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
        },
        active: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        focus: {
            boxShadowColor: 'rgba(255, 255, 255, 0.4)',
        },
    },
    black: {
        static: {
            color: Colors.text.default,
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
        },
        hover: {
            backgroundColor: 'rgba(0, 0, 0, 0.15)',
        },
        active: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        focus: {
            boxShadowColor: 'rgba(0, 0, 0, 0.4)',
        },
    },
    'black-dim': {
        static: {
            color: Colors.text.default,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        hover: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
        active: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        focus: {
            boxShadowColor: 'rgba(0, 0, 0, 0.4)',
        },
    },
};
export function getExtraDimHeaderButton(view) {
    switch (view) {
        case 'white':
            return headerButtonView['white'];
        case 'black':
            return headerButtonView['black'];
        default:
            return 'extra-dim';
    }
}
export function getPrimaryDimHeaderButton(view) {
    switch (view) {
        case 'white':
            return headerButtonView['white-dim'];
        case 'black':
            return headerButtonView['black-dim'];
        default:
            return 'primary-dim';
    }
}
export function getTransparentButtonColor(view) {
    switch (view) {
        case 'white':
            return headerButtonView['white'];
        case 'black':
            return headerButtonView['black'];
        default:
            return 'transparent';
    }
}
//# sourceMappingURL=buttonsView.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/HeaderButtons/buttonsView.js
// module id = 205
// module chunks = 118